<template>
  <div class="que-content">
    <!-- diy(题库) -->
    <template v-if="source === 1">
      <QuestionBank
        v-if="diy"
        :topic-type="params.topicType"
        :content-html="diy.contentHtml"
        :answer-parsing="diy.answerParsing"
        :answers="diy.answers"
      />
      <Loading v-else />
    </template>

    <!-- 自编题 -->
    <QuestionBank
      v-if="source === 2 && params.topicContent"
      :topic-type="params.topicType"
      :content-html="contentHtml"
      :answer-parsing="answerParsing"
      :answers="answers"
    />
  </div>
</template>
<script>
// 题相关的处理
import { computed, ref, onMounted } from '@vue/composition-api'
import QuestionBank from '@/components/QuestionBank.vue'
// import { getQuesstionInfo } from "@/service/modules/video"
import Loading from '@/components/Loading.vue'
import videoService from '@/service/video/index'
import { tkSdkNew } from '@/utils/tools.js'
export default {
  components: {
    QuestionBank,
    Loading
  },
  props: {
    params: Object
  },
  setup(props, { root, refs, emit }) {
    const params = computed(() => props.params)
    // 1 diy(题库) 2 自编题 3 视频题（定帧题）
    const source = computed(() => params.value.source)
    const contentHtml = computed(() => {
      const { topicContent } = params.value
      return topicContent
    })
    const answerParsing = computed(() => {
      const { topicOptionList } = params.value
      return topicOptionList.map(item => ({
        option: item.optionValue,
        contentHtml: item.optionContent
      }))
    })
    const answers = computed(() => {
      const { correctAnswer } = params.value
      return [
        {
          option: correctAnswer
        }
      ]
    })
    const diy = ref(null)
    async function getDiy() {
      const { topicId } = params.value
      const res = await videoService.getQuesstionInfo({ topicId })
      diy.value = res
      root.$nextTick(() => {
        tkSdkNew.runMathjax()
      })
    }
    onMounted(() => {
      if (source.value === 1) {
        getDiy()
      }
    })
    return {
      diy,
      source,
      contentHtml,
      answerParsing,
      answers
    }
  }
}
</script>
<style lang="less" scoped>
.que-content {
  background: #f5f7f9;
  box-sizing: border-box;
  border-radius: 12px;
  max-height: 422px;
  // max-height: 60vh;
  overflow-y: auto;
  padding: 24px;
}
</style>
